// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BusinessGrantViewOpenListEvent
 */
export var BusinessGrantViewOpenList = function (_a) {
    var entryPoint = _a.entryPoint;
    return ({
        name: "BusinessGrant View OpenList",
        parameters: {
            cdf_entity: "BusinessGrant",
            cdf_action: "View",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessGrantViewOpenDetailsEvent
 */
export var BusinessGrantViewOpenDetails = function (_a) {
    var grantId = _a.grantId;
    return ({
        name: "BusinessGrant View OpenDetails",
        parameters: {
            cdf_entity: "BusinessGrant",
            cdf_action: "View",
            grant_id: grantId !== undefined && grantId !== null ? grantId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessGrantViewCloseDetailsEvent
 */
export var BusinessGrantViewCloseDetails = function (_a) {
    var grantId = _a.grantId;
    return ({
        name: "BusinessGrant View CloseDetails",
        parameters: {
            cdf_entity: "BusinessGrant",
            cdf_action: "View",
            grant_id: grantId !== undefined && grantId !== null ? grantId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessGrantRemoveStartEvent
 */
export var BusinessGrantRemoveStart = function (_a) {
    var grantId = _a.grantId;
    return ({
        name: "BusinessGrant Remove Start",
        parameters: {
            cdf_entity: "BusinessGrant",
            cdf_action: "Remove",
            grant_id: grantId !== undefined && grantId !== null ? grantId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessGrantRemoveCancelEvent
 */
export var BusinessGrantRemoveCancel = function (_a) {
    var grantId = _a.grantId;
    return ({
        name: "BusinessGrant Remove Cancel",
        parameters: {
            cdf_entity: "BusinessGrant",
            cdf_action: "Remove",
            grant_id: grantId !== undefined && grantId !== null ? grantId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BusinessGrantRemoveConfirmEvent
 */
export var BusinessGrantRemoveConfirm = function (_a) {
    var grantId = _a.grantId, result = _a.result;
    return ({
        name: "BusinessGrant Remove Confirm",
        parameters: {
            cdf_entity: "BusinessGrant",
            cdf_action: "Remove",
            grant_id: grantId !== undefined && grantId !== null ? grantId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
